import CheckboxGroupRenderer from './field-types/CheckboxGroupRenderer';
import MultipleAutocompleteRenderer from './field-types/MultipleAutocompleteRenderer';
import NumberFieldRenderer from './field-types/NumberFieldRenderer';
import RadioFieldRenderer from './field-types/RadioFieldRenderer';
import SupplierFieldRenderer from './field-types/SupplierFieldRenderer';
import SwitchFieldRenderer from './field-types/SwitchFieldRenderer';
import TextFieldRenderer from './field-types/TextFieldRenderer';

// Default if type not found
// eslint-disable-next-line testing-library/render-result-naming-convention
const DefaultRenderer = NumberFieldRenderer;

export const fieldRendererRegistry = {
  text: TextFieldRenderer,
  radio: RadioFieldRenderer,
  switch: SwitchFieldRenderer,
  'checkbox-group': CheckboxGroupRenderer,
  number: NumberFieldRenderer,
  autocomplete: MultipleAutocompleteRenderer,
  supplier: SupplierFieldRenderer
};

export const getFieldRenderer = field => fieldRendererRegistry[field.type] || DefaultRenderer;
